import Api from '@/api'
import PermissionFilter from '@/utilities/auth/permission/data/PermissionFilter'

const api = new Api()
const apiAdjustment = api.adjustment()

export default {
  async fetchOptions({ commit }) {
    try {
      const { data } = await apiAdjustment.role().options()
      const { roles: roleList, users } = data.data

      const roles = roleList.map(role => ({
        ...role,
        permissions: new PermissionFilter(role.permissions).filter(),
      }))

      commit('setRoles', roles)
      commit('setUsers', users)

      return { roles, users }
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async update({ commit }, payload) {
    try {
      await apiAdjustment.role().update(payload)

      commit('updateUserRole', { userId: payload.user.id, roleId: payload.role.id })
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
